import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'
import { UsersDeleteData } from '../../../types/users'
import { useApiPostMutation } from '../useApi'

export const useUsersDelete = () => {
  const queryClient = useQueryClient()

  const mutation = useApiPostMutation<ApiResponse, UsersDeleteData>()

  return {
    ...mutation,
    mutate: (data: UsersDeleteData, options?: any) => {
      mutation.mutate(
        {
          url: '/users/delete',
          data,
        },
        {
          onSuccess: (result) => {
            queryClient.invalidateQueries({ queryKey: ['usersList'] })
            queryClient.invalidateQueries({ queryKey: ['userDetail', data.ID] })

            options?.onSuccess?.(result)
          },
          onError: (error) => {
            options?.onError?.(error)
          },
        }
      )
    },
  }
}
